export default "__VITE_ASSET__Bh621FWM__"